<section class="home-banner" *ngIf="banners.length > 0">
  <div
    class="home-banner__slide"
    [style.backgroundImage]="'url(' + currentBanner?.imageUrl + ')'"
  >
    <div class="home-banner__overlay">
      <div class="site-content">
        <div class="home-banner__content">
        <div class="home-banner__text">
          <h2 class="home-banner__title">{{ currentBanner?.title }}</h2>
          <p class="home-banner__subtitle">{{ currentBanner?.subtitle }}</p>
        </div>
        <a
          *ngIf="currentBanner?.buttonText && currentBanner?.buttonUrl"
          [href]="currentBanner!.buttonUrl"
          class="home-banner__btn"
        >
          {{ currentBanner?.buttonText }}
          <span class="home-banner__btn-icon">&#8594;</span>
        </a>
        </div>
      </div>
    </div>
  </div>

  <div class="home-banner__dots" *ngIf="banners.length > 1">
    <button
      *ngFor="let banner of banners; let i = index"
      class="home-banner__dot"
      [class.home-banner__dot--active]="i === currentIndex"
      (click)="goTo(i)"
      [attr.aria-label]="'Ir al banner ' + (i + 1)"
    ></button>
  </div>
</section>
